import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CardContent, CardHeader, CardTitle } from './Card';
import Button from './Button';
import Modal from './Modal';

const WelcomeDialog = ({ isOpen, onClose, onConfirm }) => {
  const [displayWelcome, setDisplayWelcome] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setDisplayWelcome(true);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(displayWelcome);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onEnter={handleConfirm}
      className="w-full max-w-lg mx-4"
    >
      <CardHeader className="pr-10">
        <CardTitle className="text-gray-900">Welcome</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-gray-700 space-y-4 mb-4">
          <p>
            Welcome to the new and improved Cube, powered by the FastCube team. We&apos;re excited to have you onboard.
          </p>
          <p>
            To get the most out of the Cube, your universe (the MD5s your organization can target or has data on) needs to be uploaded first. Once it&apos;s in, a full suite of tools opens up, including Dashboards, Offer Analysis, Segments, and FastID Reporting. Only one person needs to upload the universe. From there, it powers the Cube for everyone in your organization.
          </p>
          <p>
            You can upload your universe in two ways: through the Cube&apos;s{' '}
            <Link
              to="/file-upload"
              onClick={onClose}
              className="text-[#0062FB] hover:underline font-medium"
            >
              Upload page
            </Link>{' '}
            or via the{' '}
            <Link
              to="/api-keys"
              onClick={onClose}
              className="text-[#0062FB] hover:underline font-medium"
            >
              API
            </Link>
            .
          </p>
        </div>
        <label className="flex items-center space-x-2 mb-4 text-sm text-gray-700 cursor-pointer">
          <input
            type="checkbox"
            checked={displayWelcome}
            onChange={(e) => setDisplayWelcome(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-[#0062FB] focus:ring-[#0062FB]"
          />
          <span>Display welcome message</span>
        </label>
        <div className="flex justify-end">
          <Button variant="outline" onClick={handleConfirm}>
            OK
          </Button>
        </div>
      </CardContent>
    </Modal>
  );
};

export default WelcomeDialog;
